import api from "../../index";

export const GetDeletedFileApi = (data) => api.post("get-deleted-files", data);
export const RestoreFileApi = (data) => api.post("restore-deleted-files", data);
export const PermanentlyDeleteFileApi = (data) => api.post("permenentdeletedfile", data);
